/* VicHoorn shipping calculator (adapted from KABAK).
 * Calls /cart/shipping_rates.json honestly: pre-flights /cart.js so an empty
 * cart shows the right CTA instead of a confusing rate. CEP→province inferred
 * from the official BR ranges so /cart/shipping_rates.json validates.
 */
(function () {
  if (window.__vhShippingCalc) return;
  window.__vhShippingCalc = true;

  const cepRanges = [
    [1000,19999,'São Paulo'], [20000,28999,'Rio de Janeiro'], [29000,29999,'Espírito Santo'],
    [30000,39999,'Minas Gerais'], [40000,48999,'Bahia'], [49000,49999,'Sergipe'],
    [50000,56999,'Pernambuco'], [57000,57999,'Alagoas'], [58000,58999,'Paraíba'],
    [59000,59999,'Rio Grande do Norte'], [60000,63999,'Ceará'], [64000,64999,'Piauí'],
    [65000,65999,'Maranhão'], [66000,68899,'Pará'], [68900,68999,'Amapá'],
    [69000,69299,'Amazonas'], [69300,69399,'Roraima'], [69400,69899,'Amazonas'],
    [69900,69999,'Acre'], [70000,72799,'Distrito Federal'], [72800,72999,'Goiás'],
    [73000,73699,'Distrito Federal'], [73700,76799,'Goiás'], [76800,76999,'Rondônia'],
    [77000,77999,'Tocantins'], [78000,78899,'Mato Grosso'], [78900,78999,'Rondônia'],
    [79000,79999,'Mato Grosso do Sul'], [80000,87999,'Paraná'], [88000,89999,'Santa Catarina'],
    [90000,99999,'Rio Grande do Sul'],
  ];

  const STRINGS = {
    addToCartFirst: 'Adicione o produto ao carrinho para calcular o frete com precisão.',
    addToCartCta:   'Adicionar ao carrinho',
    cartEstimateNote:'Estimativa baseada nos itens atuais do carrinho.',
    requestError:   'Não foi possível consultar o frete agora. Tente novamente.',
    invalidZip:     'Informe um CEP válido (8 dígitos).',
    noRates:        'Desculpe, não enviamos para seu endereço.',
    oneRate:        'Existe uma taxa de envio para o seu endereço:',
    multipleRates:  'Existem várias taxas de envio para o seu endereço:',
  };

  const cartUrl     = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
  const cartJsonUrl = (cartUrl + '.js').replace('//.js', '/.js');
  const ratesUrl    = (cartUrl + '/shipping_rates.json').replace(/([^:])\/\//g, '$1/');

  const inferProvince = (zip) => {
    const digits = String(zip || '').replace(/\D/g, '');
    if (digits.length < 5) return '';
    const prefix = Number(digits.slice(0, 5));
    const r = cepRanges.find(([min, max]) => prefix >= min && prefix <= max);
    return r ? r[2] : '';
  };

  const formatZip = (v) => {
    const d = String(v || '').replace(/\D/g, '').slice(0, 8);
    if (d.length > 5) return d.slice(0, 5) + '-' + d.slice(5);
    return d;
  };

  const escapeHtml = (s) => String(s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

  function setResult(form, { state, html }) {
    const box = form.querySelector('[data-vh-result]');
    if (!box) return;
    box.hidden = false;
    box.dataset.state = state;
    box.innerHTML = html;
  }

  function focusBuyButton() {
    const candidates = [
      'product-form button[name="add"]:not([disabled])',
      'form[action*="/cart/add"] button[name="add"]:not([disabled])',
      'form[action*="/cart/add"] [type="submit"]:not([disabled])',
    ];
    let t = null;
    for (const sel of candidates) { t = document.querySelector(sel); if (t) break; }
    if (!t) return;
    t.scrollIntoView({ behavior: 'smooth', block: 'center' });
    try { t.focus({ preventScroll: true }); } catch (_) { t.focus(); }
  }

  const inFlight = new WeakMap();

  async function handleSubmit(form) {
    const submitBtn = form.querySelector('[type="submit"]');
    const zipInput  = form.querySelector('[name="address[zip]"]');
    const country   = form.querySelector('[name="address[country]"]').value || 'Brazil';
    const provinceInput = form.querySelector('[name="address[province]"]');

    const digits = (zipInput?.value || '').replace(/\D/g, '');
    if (digits.length < 8) {
      setResult(form, { state: 'error', html: `<p>${escapeHtml(STRINGS.invalidZip)}</p>` });
      return;
    }
    provinceInput.value = inferProvince(digits);

    const previous = inFlight.get(form);
    if (previous) previous.abort();
    const controller = new AbortController();
    inFlight.set(form, controller);

    if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');

    try {
      const cartResp = await fetch(cartJsonUrl, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        signal: controller.signal,
        credentials: 'same-origin',
      });
      let cart;
      try {
        cart = await cartResp.json();
      } catch (e) {
        if (!cartResp.ok) throw new Error(`Cart fetch failed: HTTP ${cartResp.status} (non-JSON response)`);
        throw e;
      }

      if (!cart || typeof cart.item_count !== 'number') {
        renderApiError(form, null);
        return;
      }

      if (cart.item_count === 0) {
        setResult(form, {
          state: 'info',
          html: `<p>${escapeHtml(STRINGS.addToCartFirst)}</p>
                 <button type="button" class="vh-shipping-calc__cta" data-vh-empty-cta>${escapeHtml(STRINGS.addToCartCta)}</button>`,
        });
        return;
      }

      const ratesResp = await fetch(ratesUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ shipping_address: { zip: digits, country, province: provinceInput.value } }),
        signal: controller.signal,
        credentials: 'same-origin',
      });
      let data;
      try {
        data = await ratesResp.json();
      } catch (e) {
        if (!ratesResp.ok) throw new Error(`Rates fetch failed: HTTP ${ratesResp.status} (non-JSON response)`);
        throw e;
      }

      if (data && Array.isArray(data.shipping_rates)) {
        renderRates(form, data.shipping_rates);
      } else {
        renderApiError(form, data);
      }
    } catch (err) {
      if (err && err.name === 'AbortError') return;
      console.error('[vh-shipping-calc]', err);
      renderApiError(form, null);
    } finally {
      if (inFlight.get(form) === controller) inFlight.delete(form);
      if (submitBtn) submitBtn.removeAttribute('aria-busy');
    }
  }

  function renderRates(form, rates) {
    if (!rates.length) {
      setResult(form, { state: 'error', html: `<p>${escapeHtml(STRINGS.noRates)}</p>` });
      return;
    }
    const heading = rates.length === 1 ? STRINGS.oneRate : STRINGS.multipleRates;
    const items = rates.map(({ presentment_name, price }) => {
      // shopify returns price as string ("12.50") in store currency
      const cents = Math.round(parseFloat(price) * 100);
      const money = window.Shopify && window.Shopify.formatMoney
        ? Shopify.formatMoney(cents, (window.theme && theme.moneyFormat) || '${{amount}}')
        : 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
      return `<li class="vh-rate"><strong>${escapeHtml(presentment_name)}</strong><span>${escapeHtml(money)}</span></li>`;
    }).join('');
    setResult(form, {
      state: 'success',
      html: `<p>${escapeHtml(heading)}</p>
             <ul class="vh-rate-list" role="list">${items}</ul>
             <p class="vh-shipping-calc__note">${escapeHtml(STRINGS.cartEstimateNote)}</p>`,
    });
  }

  function renderApiError(form, errors) {
    let lines = [];
    if (errors && typeof errors === 'object') {
      for (const key of Object.keys(errors)) {
        const v = errors[key];
        if (Array.isArray(v)) v.forEach((m) => lines.push(String(m)));
        else if (v) lines.push(String(v));
      }
    }
    const extra = lines.length
      ? `<ul class="vh-rate-list">${lines.map((m) => `<li>${escapeHtml(m)}</li>`).join('')}</ul>` : '';
    setResult(form, {
      state: 'error',
      html: `<p>${escapeHtml(STRINGS.requestError)}</p>${extra}`,
    });
  }

  /* Wire up via event delegation so it works for multiple/late forms. */
  document.addEventListener('input', (e) => {
    const inp = e.target.closest('[data-vh-shipping-form] [name="address[zip]"]');
    if (!inp) return;
    const v = formatZip(inp.value);
    if (inp.value !== v) {
      const pos = inp.selectionStart || 0;
      inp.value = v;
      try { inp.setSelectionRange(pos + 1, pos + 1); } catch (_) {}
    }
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-vh-shipping-form]');
    if (!form) return;
    e.preventDefault();
    handleSubmit(form);
  }, true);

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-vh-empty-cta]')) {
      e.preventDefault();
      focusBuyButton();
    }
  });
})();
